<div class="content-layout left-sidebar-fullheight-basic-inner-scroll">
  <mat-drawer-container>
    <mat-drawer [mode]="drawerMode" [opened]="drawerOpened" #drawer>
      <app-deals-sidebar *ngIf="newUi"></app-deals-sidebar>
      <!-- Mailbox sidebar -->
      <projects-sidebar *ngIf="!newUi"></projects-sidebar>
    </mat-drawer>

    <mat-drawer-content>
      <!-- Main -->
      <div class="main">
        <router-outlet></router-outlet>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
